import React, { useState, useEffect, forwardRef } from 'react';
import axios from 'axios';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TableContainer,
  Grid,
  Breadcrumbs,
  Snackbar,
  CircularProgress,
  Box,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Link } from 'react-router-dom';
import MuiAlert from '@mui/material/Alert';
import api from 'services/api';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UsuariosNaoAprovados = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  useEffect(() => {
    const fetchUsuariosNaoAprovados = async () => {
      setCarregando(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/usuarios/nao-aprovados`);
        setUsuarios(response.data.usuariosNaoAprovados);
        setCarregando(false);
      } catch (error) {
        setError('Erro ao buscar usuários não aprovados.');
        setCarregando(false);
      }
    };

    fetchUsuariosNaoAprovados();
  }, []);

  const handleAccept = async (id) => {
    try {
      await api.post(`/admin/usuarios/aceitar`, { id });
      setUsuarios(usuarios.filter((usuario) => usuario.id !== id));
      setSnackbarMessage(`Usuário foi aprovado e o e-mail foi enviado.`);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Erro ao aceitar usuário e enviar o e-mail:', error);
      setSnackbarMessage('Erro ao aceitar usuário e enviar o e-mail.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleReject = async (id) => {
    try {
      await api.post(`/admin/usuarios/recusar`, { id });
      setUsuarios(usuarios.filter((usuario) => usuario.id !== id));
      setSnackbarMessage(`Usuário com ID ${id} foi recusado com sucesso.`);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Erro ao recusar usuário:', error);
      setError('Erro ao recusar usuário.');
      setSnackbarMessage('Erro ao recusar usuário.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Grid container justifyContent="center" sx={{ paddingLeft: 2, minHeight:'88vh' }}>
      <Grid item xs={12} md={8} lg={12}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 2 }}>
          <Link color="inherit" to="/admin/principal">
            Home
          </Link>
          <Typography color="textPrimary">Solicitações</Typography>
        </Breadcrumbs>

        {carregando ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
            <Table sx={{ minWidth: 650, borderCollapse: 'separate', borderSpacing: '0 10px' }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Nome</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>UF</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Município</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {usuarios.map((usuario) => (
                  <TableRow key={usuario.id}>
                    <TableCell>{usuario.id}</TableCell>
                    <TableCell>{usuario.nome}</TableCell>
                    <TableCell>{usuario.email}</TableCell>
                    <TableCell>{usuario.uf}</TableCell>
                    <TableCell>{usuario.municipio}</TableCell>
                    <TableCell>{usuario.status}</TableCell>
                    <TableCell sx={{ display: 'flex', justifyContent: 'space-around' }}>
                      <IconButton color="primary" onClick={() => handleAccept(usuario.id)}>
                        <CheckIcon />
                      </IconButton>
                      <IconButton color="secondary" onClick={() => handleReject(usuario.id)}>
                        <ClearIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Grid>
    </Grid>
  );
};

export default UsuariosNaoAprovados;
